import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ErrorPage } from './modules/pages/error/ErrorPage';
import { MaintenancePage } from './modules/pages/maintenance/MaintenancePage';
import { LauncherPage } from './modules/pages/launcher/LauncherPage';
import { HomePage } from './modules/pages/home/HomePage';
import { FreeBetAwardModal } from "./modules/components/free-bet/free-bet-award/free-bet-award-modal";
import { FreeBetEnd } from "./modules/components/free-bet/free-bet-end/free-bet-end";
import posthog from 'posthog-js'
import { Promo } from "./modules/components/promo/Promo";
import { DailyWheel } from "./modules/components/daily-wheel";
import { Tournament } from "./modules/components/tournament/Tournament";
import { ConnectionLostModal } from "./modules/components/connection-lost/ConnectionLostModal";
import { stripUrlQueries } from "./platform/utils/analytics";

function App() {
  useEffect(() => {
    posthog.init(process.env.REACT_APP_POSTHOG_TOKEN!,
      {
        api_host: 'https://eu.i.posthog.com',
        person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
        before_send: stripUrlQueries,
        // person_profiles: 'always'
      }
    )

    if (process.env.REACT_APP_ENVIRONMENT !== 'Production') {
      posthog.opt_out_capturing();
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage/>}/>
        <Route path="error" element={<ErrorPage/>}/>
        <Route path="launcher/*" element={<LauncherPage/>}/>
        <Route path="maintenance" element={<MaintenancePage/>}/>
      </Routes>

      <Tournament/>
      <FreeBetEnd/>
      <FreeBetAwardModal/>
      <Promo/>
      <DailyWheel/>
      <ConnectionLostModal/>
    </BrowserRouter>
  );
}

export default App;
